import {Template, Component, Attribute} from '@scoutgg/ftw/source/lib'
import { Season, PlayerSource, Player, Team } from '../../models'
import template from './edit-player-source.jade'
import emitter from '@scoutgg/ftw/source/services/emitter'

import { countries } from 'country-data'
import sources from '../../../helpers/sources'
import { enum as genderEnum } from '../../../models/concerns/gender'

const prices = Symbol('prices')

@Component('sporty')
@Template(template)
@Attribute('season', Season)
@Attribute('player', Player)

export default class EditPlayerSource extends HTMLElement {
  attached() {
    this.team = this.player?.team
    this.position = this.player?.position
    this.country = this.player?.country
    this.gender = this.player?.gender
    this.player.overrideTeam = this.player.overridedTeam || this.overridedTeam[0]
    this.update(PlayerSource.load({season: this.season._id, $reload: true}))
    this.countries = countries.all.sort((a, b) => a.name.localeCompare(b.name))
    this.genders = genderEnum
    this.render()
  }

  toggleDisabled(player) {
    const price = this.getPrice(player)
    price.disabled = !price.disabled
    price.$changed = true
  }

  editPlayerTeamPos(player, attr, team, pos) {
    if(team) {
      this.player[attr] = Team.instance(team)
      this.team = team
    }
    if(pos) {
      this.player[attr] = pos
      this.position = pos
    }
    this.render()
  }

  editPlayerCountry(player, country) {
    this.player.country = country
    this.country = country
    this.render()
  }

  editPlayerGender(player, gender) {
    this.player.gender = gender
    this.gender = gender
    this.render()
  }

  closeModal(save) {
    if(save) emitter.emit('player:edited', {player: this.player})
    if(this.player._id === '-1') this.uncachePlayerFields()
    this.parentNode.close()
  }

  uncachePlayerFields() {
    delete this.player.overrideTeam
    delete this.player.position
    for(let key in this.player) {
      if(key !== '_id') delete this.player[key]
    }
  }

  getCsvSource() {
    if(!this.player) return null
    if(this.player._id < 0) return null
    return this.seasonSources?.find(ss => {
      return sources[ss.source]?.csvForPlayer
    })
  }

  get canUploadCsv() {
    return this.csvUploadData && !this.$isSubmitting
  }

  async uploadCsv() {
    if(this.$isSubmitting) return
    this.$isSubmitting = true
    try {
      this.getCsvSource().post('player-csv', {
        player: this.player._id,
        csv: this.csvUploadData,
      })
    } catch(err) {
      console.error(err)
    } finally {
      this.applyState({ $isSubmitting: false })
    }
  }

  getPrice(player) {
    if(!this.prices) return
    return this.prices.find(p => p.playerId === player._id)
  }

  get overridedTeam() {
    return this.player?.playerSources
      .filter(s => s.overrideTeam)
      .map(({overrideTeam}) => overrideTeam)
  }

  get sortedTeams() {
    return (this.teams || [])
      .sort((a, b) => {
        return a.name - b.name
      })
      .filter(a => !a.notAvailable)
  }
  get positions() {
    return this.season?.positions
  }
}
